const COOKIE_NAME = "rifa365_platform_ref";
const DAYS = 30;

function setCookie(name, value, days) {
  const maxAge = days * 24 * 60 * 60;
  const secure =
    typeof window !== "undefined" && window.location?.protocol === "https:"
      ? "; Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(
    String(value)
  )}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const [k, ...rest] = part.trim().split("=");
    if (k === name) {
      try {
        return decodeURIComponent(rest.join("=") || "");
      } catch (e) {
        return rest.join("=") || "";
      }
    }
  }
  return null;
}

/** Persist platform affiliate ref (?ref=ID) for 30 days. */
export function capturePlatformAffiliateRef(ref) {
  if (ref == null || ref === "") return;
  const id = parseInt(String(ref), 10);
  if (!Number.isFinite(id) || id <= 0) return;
  try {
    setCookie(COOKIE_NAME, id, DAYS);
  } catch (e) {
    /* ignore */
  }
}

/** Read stored ref (integer) or null. */
export function getPlatformAffiliateRef() {
  try {
    const raw = getCookie(COOKIE_NAME);
    if (!raw) return null;
    const id = parseInt(raw, 10);
    if (!Number.isFinite(id) || id <= 0) return null;
    return id;
  } catch (e) {
    return null;
  }
}

/**
 * Prefer URL ?ref=, else cookie. Always refresh cookie when URL has ref.
 */
export function resolvePlatformAffiliateRef(queryRef) {
  if (queryRef != null && queryRef !== "") {
    capturePlatformAffiliateRef(queryRef);
    const id = parseInt(String(queryRef), 10);
    if (Number.isFinite(id) && id > 0) return id;
  }
  return getPlatformAffiliateRef();
}

export const PLATFORM_AFFILIATE_REF_DAYS = DAYS;
